export const PAGE_VIEW_MODES = {
  VIEW: 'view',
  ADD: 'add',
  EDIT: 'edit'
};
